import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { graphql, Link, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import StyledButton from "../../common/styledButton"
import "./blockConfigExperience.scss"
import HTMLReactParser from "html-react-parser"
import { useIntl } from "gatsby-plugin-react-intl"
import {
  FormControl,
  InputLabel,
  MenuItem ,
  Select ,
} from "@mui/material"

const BlockConfigExperience = ({locale, genres, hotel}) => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
  query blockExperienceQuery{
    blkExperienceContentEN : allBlockContentBlockCollectableExperiences(filter: {langcode: {eq: "en"}, block_experiences_title: { ne: "test" }}) {
      nodes {
        block_experiences_title
        block_experiences_subtitle
        block_experiences_genre_title
        block_experiences_menu_text
        block_experiences_menu_genre
        block_experiences_menu_title
        body {
          processed
        }
        block_experiences_cta {
          title
          url
        }
        block_experiences_menu_cta {
          title
          url
        }
        relationships {
          image_left {
            relationships {
              ...getImage
            }
          }
          image_right_1 {
            ... on media__image {
              field_image {
                alt
              }
              internal {
                type
              }
              relationships {
                ...getImage
              }
            }
            ... on media__video {
              internal {
                type
              }
              relationships {
                field_media_video_file {
                  publicUrl
                }
              }
            }
          }
          image_right_2 {
            relationships {
              ...getImage
            }
          }
          block_experiences_menu_image {
            relationships {
              ...getImage
            }
          }
        }
      }
    }
    blkExperienceContentFR : allBlockContentBlockCollectableExperiences(filter: {langcode: {eq: "fr"}, block_experiences_title: { ne: "test" }}) {
      nodes {
        block_experiences_title
        block_experiences_subtitle
        block_experiences_genre_title
        block_experiences_menu_text
        block_experiences_menu_genre
        block_experiences_menu_title
        body {
          processed
        }
        block_experiences_cta {
          title
          url
        }
        block_experiences_menu_cta {
          title
          url
        }
        relationships {
          image_left {
            relationships {
              ...getImage
            }
          }
          image_right_1 {
            ... on media__image {
              field_image {
                alt
              }
              internal {
                type
              }
              relationships {
                ...getImage
              }
            }
            ... on media__video {
              internal {
                type
              }
              relationships {
                field_media_video_file {
                  publicUrl
                }
              }
            }
          }
          image_right_2 {
            relationships {
              ...getImage
            }
          }
          block_experiences_menu_image {
            relationships {
              ...getImage
            }
          }
        }
      }
    }
  }
  `)
  let dataExperiencePlan
  switch (locale) {
    case "fr":
      if (data.blkExperienceContentFR) {
        dataExperiencePlan = data.blkExperienceContentFR.nodes[0]
      }
      break
    default:
      if (data.blkExperienceContentEN) {
        dataExperiencePlan = data.blkExperienceContentEN.nodes[0]
  }
}

  const [selectedGenre, setSelectedGenre] = useState("")
  const inputRef = React.useRef(null)
  const handleGenreChange = event => {
    setSelectedGenre(event.target.value)
    //Set click on submit after radio change
    setTimeout(() => {
      inputRef.current.click()
    }, 500)
  }

  return (
    <section className="blk-configExperience" >
      <Container>
        <Row>
          <Col md={3}>
            <div className="animImgRight">
              <GatsbyImage
                  image={getImage(
                    dataExperiencePlan.relationships.image_left?.relationships.field_image?.gatsbyImage
                  )}
                  height="auto"
                />
            </div>
          </Col>
          <Col md={4}>
            <div className="animTxt experienceContent">
              {dataExperiencePlan.block_experiences_subtitle && (
                <span className="caption">{dataExperiencePlan.block_experiences_subtitle}</span>
              )}
              {dataExperiencePlan.block_experiences_title && (
                <h3 className="font-style_1 animTxt">{dataExperiencePlan.block_experiences_title}</h3>
              )}

              {dataExperiencePlan.body && (
                <div className="description animTxt">{HTMLReactParser(dataExperiencePlan.body.processed)}</div>
              )}
              <form
                className="formExperience animTxt"
                action={dataExperiencePlan.block_experiences_cta.url}
                method="GET"
              >
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                  {dataExperiencePlan.block_experiences_menu_genre && (
                    <InputLabel className="genreTitle animTxt">{dataExperiencePlan.block_experiences_menu_genre}</InputLabel>
                  )}
                  <div className="genreExp">
                    {genres && genres.length > 0 && (
                      <Select name="genre" className="genre">
                        <MenuItem value="form_inputs.all_genre">
                          {intl.formatMessage({
                            id: "form_inputs.all_genre",
                          })}
                        </MenuItem>
                        {genres
                          .filter(
                            genres =>
                              genres
                          )
                          .map((genresAdventure, index) => {
                            return (
                              <MenuItem key={index} value={genresAdventure.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}>
                                {genresAdventure.name}
                              </MenuItem>
                            )
                          })}
                      </Select>
                    )}
                    <select name="hotel" className="hotel">
                      <option value={hotel}></option>
                    </select>
                    <button className="btn btnPrimary" type="submit">
                    <span>
                      {dataExperiencePlan.block_experiences_cta.title}
                    </span>
                    </button>
                  </div>
                </FormControl>
              </form>
            </div>
          </Col>
          <Col md={5} >
            <div className="img-right">
              <div className="img-right-primary illusAnim illusAnimLeft">
              {dataExperiencePlan.relationships.image_right_1?.internal.type ===
                "media__image" ? (
                  <GatsbyImage
                    image={getImage(
                      dataExperiencePlan.relationships.image_right_1.relationships.field_image?.gatsbyImage
                    )}
                    alt={dataExperiencePlan.relationships.image_right_1.field_image.alt}
                    height="auto"
                  />
                ) : (
                  <video autoPlay={1} loop muted>
                    <source
                      src={
                        dataExperiencePlan.relationships.image_right_1?.relationships.field_media_video_file?.publicUrl
                      }
                      type="video/mp4"
                    />
                  </video>
                )}
              </div>
              <div className="img-right-secondary illusAnim illusAnimLeft">
                <GatsbyImage
                  image={getImage(
                    dataExperiencePlan.relationships.image_right_2?.relationships.field_image?.gatsbyImage
                  )}
                  height="auto"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default BlockConfigExperience
